import { gql } from "@apollo/client";
import { SuccessDeepNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const UPLOAD_IMAGES_TO_RETAILER = gql`
  ${SuccessDeepNestingFragment}
  mutation uploadImagesToRetailerByImageId($productId: ID!, $imageIds: [ID!]!) {
    uploadImagesToRetailerByImageId(
      productId: $productId
      imageIds: $imageIds
    ) {
      ...SuccessDeepNesting
    }
  }
`;
